import { TrackingMetaData } from '../domains/CustomSection'

const getContentContainerDetails = (
  trackingMetaData?: TrackingMetaData,
): {
  contentContainerType?: string
  contentContainerName?: string
  contentContainerDisplayName?: string
} => {
  return {
    contentContainerType: trackingMetaData?.context?.contentContainerType,
    contentContainerName: trackingMetaData?.context?.contentContainerName,
    contentContainerDisplayName: trackingMetaData?.context?.contentContainerDisplayName,
  }
}

export default getContentContainerDetails
